import { urls } from "../../../../urls";

export const v1SupplierViewLinkToV2 = (eventId: string, search: string): string => {
  const params = new URLSearchParams(search);
  const question = params.get("question");
  const announcement = params.get("announcement");

  if (question) return urls.v2.supplier.procurement.question(eventId, question);
  if (announcement) return urls.v2.supplier.procurement.announcement(eventId, announcement);
  return urls.v2.supplier.procurement.go(eventId);
};
